module.exports = __webpack_public_path__ + "img/1v1.28dc34a9.png";